<template>
  <div>
    <div v-if="!isPlatform">
      <fdk-accounts v-slot="accountsData">
        <div>
          <slot v-bind="accountsData"></slot>
        </div>
      </fdk-accounts>
    </div>

    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import { checkIsPlatform } from "@/utils/utils"

  export default {
    name: "CustomFdkAccount",
    computed: {
      isPlatform() {
        return checkIsPlatform()
      },
    },
  }
</script>
